module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showButton) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.viewPurchaseApproverDetails()
      }
    }
  }, [_vm._v("View Purchase Approvers")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "purchase-approver-modal",
    attrs: {
      "id": "purchase-approver-modal",
      "title": "Purchase Approver Details",
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.purchaseApproverList.length > 0) ? _c('div', _vm._l((_vm.purchaseApproverList), function(approver, index) {
    return _c('b-card', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      }
    }, [_c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: ('accordion-' + index),
        expression: "'accordion-' + index"
      }],
      staticClass: "text-left",
      staticStyle: {
        "background-color": "#36304a !important",
        "border-color": "#36304a !important",
        "color": "#ffffff !important"
      },
      attrs: {
        "block": "",
        "variant": "primary"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center w-100",
      staticStyle: {
        "color": "#ffffff !important"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#ffffff !important"
      }
    }, [_c('b-badge', {
      staticClass: "mr-2",
      attrs: {
        "variant": approver.isActive == 1 ? 'success' : 'danger'
      }
    }, [_vm._v("\n                  " + _vm._s(approver.isActive == 1 ? "Active" : "Inactive") + "\n                ")]), _vm._v(" "), _c('strong', {
      staticStyle: {
        "color": "#ffffff !important"
      }
    }, [_vm._v(_vm._s(approver.employeeName))]), _vm._v(" "), _c('span', {
      staticClass: "ml-2",
      staticStyle: {
        "color": "#ffffff !important"
      }
    }, [_vm._v("(ID: " + _vm._s(approver.userId) + ")")])], 1), _vm._v(" "), _c('md-icon', {
      staticStyle: {
        "color": "#ffffff !important"
      }
    }, [_vm._v("expand_more")])], 1)])], 1), _vm._v(" "), _c('b-collapse', {
      attrs: {
        "id": 'accordion-' + index,
        "accordion": "purchase-approver-accordion",
        "role": "tabpanel"
      }
    }, [_c('b-card-body', [_c('b-row', {
      staticClass: "mb-1"
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h6', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Basic Information")])])]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('div', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Purchase Approver Flag:")]), _vm._v(" "), _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": approver.purchase_approver_flag == 'Yes' ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                    " + _vm._s(approver.purchase_approver_flag || "No") + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Rights Require Validation:")]), _vm._v(" "), _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": approver.ape_rights_require_validation ? 'warning' : 'info'
      }
    }, [_vm._v("\n                    " + _vm._s(approver.ape_rights_require_validation ? "Yes" : "No") + "\n                  ")])], 1)]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('div', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("User View Page Preference:")]), _vm._v(" "), _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": approver.user_view_page_pref ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                    " + _vm._s(approver.user_view_page_pref ? "Yes" : "No") + "\n                  ")])], 1)])], 1), _vm._v(" "), (approver.ape_job_type && _vm.parseArray(approver.ape_job_type).length > 0) ? _c('b-row', {
      staticClass: "mb-1"
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h6', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Job Types")])]), _vm._v(" "), _c('div', _vm._l((_vm.parseArray(approver.ape_job_type)), function(jobType, idx) {
      return _c('b-badge', {
        key: idx,
        staticClass: "mr-2 mb-2 p-2",
        staticStyle: {
          "font-size": "0.9rem"
        },
        attrs: {
          "variant": "primary"
        }
      }, [_vm._v("\n                    " + _vm._s(jobType.text) + "\n                  ")])
    }))])], 1) : _vm._e(), _vm._v(" "), (approver.ape_moduel_type && _vm.parseArray(approver.ape_moduel_type).length > 0) ? _c('b-row', {
      staticClass: "mb-1"
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h6', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Module Types")])]), _vm._v(" "), _c('div', _vm._l((_vm.parseArray(approver.ape_moduel_type)), function(moduleType, idx) {
      return _c('b-badge', {
        key: idx,
        staticClass: "mr-2 mb-2 p-2",
        staticStyle: {
          "font-size": "0.9rem"
        },
        attrs: {
          "variant": "info"
        }
      }, [_vm._v("\n                    " + _vm._s(moduleType.text) + "\n                  ")])
    }))])], 1) : _vm._e(), _vm._v(" "), (approver.ape_shipment_type && _vm.parseArray(approver.ape_shipment_type).length > 0) ? _c('b-row', {
      staticClass: "mb-1"
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h6', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Shipment Types")])]), _vm._v(" "), _c('div', _vm._l((_vm.parseArray(approver.ape_shipment_type)), function(shipmentType, idx) {
      return _c('b-badge', {
        key: idx,
        staticClass: "mr-2 mb-2 p-2",
        staticStyle: {
          "font-size": "0.9rem"
        },
        attrs: {
          "variant": "success"
        }
      }, [_vm._v("\n                    " + _vm._s(shipmentType.text) + "\n                  ")])
    }))])], 1) : _vm._e(), _vm._v(" "), (approver.branch_relation) ? _c('b-row', {
      staticClass: "mb-1"
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h6', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Branch Information")])]), _vm._v(" "), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('div', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Branch Location:")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(approver.branch_relation.mainLocation || "N/A"))])])]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('div', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Branch Code:")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(approver.branch_relation.BranchCode || "N/A"))])])]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('div', [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Pickup Location:")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(approver.branch_relation.pickupLocation || "N/A"))])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (approver.branch_relation) ? _c('b-row', [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('div', {
      staticClass: "border rounded p-3"
    }, [_c('h6', {
      staticClass: "mb-1"
    }, [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Branch Validation Rights")])]), _vm._v(" "), _c('b-row', [_c('b-col', {
      staticClass: "mb-2",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "border rounded p-2"
    }, [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("NOE Validation:")]), _c('br'), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": approver.branch_relation.is_noe_validation ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                          " + _vm._s(approver.branch_relation.is_noe_validation ? "Yes" : "No") + "\n                        ")])], 1)]), _vm._v(" "), _c('b-col', {
      staticClass: "mb-2",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "border rounded p-2"
    }, [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Expense Validation:")]), _c('br'), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": approver.branch_relation.is_expense_validation ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                          " + _vm._s(approver.branch_relation.is_expense_validation ? "Yes" : "No") + "\n                        ")])], 1)]), _vm._v(" "), _c('b-col', {
      staticClass: "mb-2",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "border rounded p-2"
    }, [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("Additional Task Validation:")]), _c('br'), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": approver.branch_relation.is_additional_task_validation ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                          " + _vm._s(approver.branch_relation.is_additional_task_validation ? "Yes" : "No") + "\n                        ")])], 1)]), _vm._v(" "), _c('b-col', {
      staticClass: "mb-2",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "border rounded p-2"
    }, [_c('strong', {
      staticStyle: {
        "color": "#000000"
      }
    }, [_vm._v("S/Line Validation:")]), _c('br'), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": approver.branch_relation.is_sline_validation ? 'success' : 'secondary'
      }
    }, [_vm._v("\n                          " + _vm._s(approver.branch_relation.is_sline_validation ? "Yes" : "No") + "\n                        ")])], 1)])], 1)], 1)])], 1) : _vm._e()], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.purchaseApproverList.length === 0) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No purchase approvers found.")])]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hidePurchaseApproverDetails
    }
  }, [_vm._v("\n      Close\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f56a4f2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/purchaseApproverDetails.vue
// module id = 2438
// module chunks = 0